import * as React from "react";
import { PageTemplate } from "../common/PageTemplate";
import { Link } from "react-router-dom";

export const PaymentFailure = (props) => {
    return <PageTemplate objectName='payments-failure' pageTitle='Failed to Make a Payment'>
        <div className='payments-failure-content'>
            <p className=''>An error occured while making a payment, please call customer service coordinator at <b>1-800-321-7947 Monday through Friday, 8 a.m. to 5 p.m.</b></p>
            <Link className='plan-page-redirect' to={{ pathname: '/benefits' }}>Go back to the Plan page</Link>
        </div>
    </PageTemplate>;
}